import ReactSkeleton from 'react-loading-skeleton';
import { rgba } from 'polished';

// Import theme
import { pureOttTheme } from 'components/theme/pure_ott_theme/pureOttTheme';

type Props = {
	children: React.ReactNode;
	isLoading: boolean;
	count?: number;
};

export const Skeleton = ({ children, isLoading, count = 1 }: Props) => {
	if (!isLoading) return children;

	return (
		<ReactSkeleton
			containerClassName="skeleton-wrapper"
			count={count}
			baseColor="transparent"
			highlightColor={rgba(pureOttTheme.configurator.bg.skeleton, 0.9)}
		/>
	);
};
